import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const n = (i) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(i),
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_8888_10710)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.13348 9.87663C-0.36741 11.3775 -0.367411 13.811 1.13348 15.3118L9.2863 23.4647C10.7872 24.9656 13.2206 24.9656 14.7215 23.4647L22.8743 15.3118C24.3752 13.811 24.3752 11.3775 22.8743 9.87663L14.7215 1.72381C13.2206 0.222921 10.7872 0.222921 9.2863 1.72381L1.13348 9.87663ZM12 18.5942C15.3137 18.5942 18 15.9079 18 12.5942C18 9.28053 15.3137 6.59424 12 6.59424C8.68629 6.59424 6 9.28053 6 12.5942C6 15.9079 8.68629 18.5942 12 18.5942Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.48578 15.2884C9.19289 14.9955 9.19289 14.5206 9.48578 14.2277L13.5234 10.1901C13.8163 9.8972 14.2912 9.8972 14.5841 10.1901C14.8769 10.483 14.8769 10.9579 14.5841 11.2508L10.5464 15.2884C10.2535 15.5813 9.77868 15.5813 9.48578 15.2884Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_8888_10710", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0 0.598145)"
        }
      ) }) })
    ]
  }
);
export {
  n as DiamondSlashIcon
};
//# sourceMappingURL=DiamondSlashIcon.js.map
